/**
 * Labstep
 *
 * @module components/ResourceItemTemplate/EmptyState
 * @desc Empty State for ResourceItem template
 */

import { ResourceFormShowEditResourceTemplate } from 'labstep-web/components/Resource/Form/ShowEdit/ResourceTemplate';
import { ResourceItemActionCreateTemplate } from 'labstep-web/components/ResourceItem/Action/Create/Template';
import { ResourceItemActionDeleteTemplate } from 'labstep-web/components/ResourceItem/Action/Delete/Template';
import { Button } from 'labstep-web/core/Button';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IResourceItemTemplateEmptyStateProps } from './types';
import { getExplanation, getTitle } from './utils';

export const EmptyStatePrimaryAction: React.FC<
  IResourceItemTemplateEmptyStateProps
> = ({ resource }) =>
  resource.resource_item_template ? (
    <ResourceItemActionDeleteTemplate
      resourceItem={resource.resource_item_template}
    />
  ) : (
    <ResourceItemActionCreateTemplate
      resource={resource as Resource}
    />
  );

export const EmptyStateSecondaryAction: React.FC<
  IResourceItemTemplateEmptyStateProps
> = ({ resource }) =>
  resource.template ? (
    <Button
      route={{
        to: 'resource_template_show_resource_item_template',
        params: { id: resource.template.id },
      }}
      basic
      primary
    >
      {`Go to ${Resource.getHumanReadableEntityName(
        false,
        true,
        true,
      )}`}
    </Button>
  ) : (
    <ResourceFormShowEditResourceTemplate
      resource={resource as Resource}
    />
  );

export const ResourceItemTemplateEmptyState: React.FC<
  IResourceItemTemplateEmptyStateProps
> = ({ resource }) => (
  <CardEmptyState
    title={getTitle(resource as Resource)}
    explanation={getExplanation(resource as Resource)}
    src="/img/empty-state/inventory.svg"
    action={<EmptyStatePrimaryAction resource={resource} />}
    secondaryAction={
      !resource.is_template && (
        <EmptyStateSecondaryAction resource={resource} />
      )
    }
  />
);
